import { isDigit } from "math"
import { arrayFit } from "../array"

type IStrCond =
  | [boolean | undefined | null, string | undefined]
  | [boolean | undefined | null, string | undefined, string | undefined]

export const condcat = (conditions: IStrCond[], joinDelim: string = ''): string => {
  const items: string[] = []

  for (const cond of conditions) {
    if (cond[0]) items.push(cond[1] || '')
    else if (cond.length >= 3 && cond[2]) items.push(cond[2] || '')
  }

  return items.join(joinDelim)
}

export const clip = (v: string, limit: number): string => {
  if (!v) return v;
  if (v.length < limit) return v
  const cut = cutEnd(Array.from(v).splice(0, limit).join(''), ['–', '-'])
  return `${cut}...`
}

export const cutEnd = (v: string, end: string | string[]): string => {
  const removeLast = (v: string, end: string) => {
    if (!v.endsWith(end)) return v
    const chars = Array.from(v)
    const cutLen = end.length
    return chars.filter((_, i) => i < chars.length - cutLen).join('')
  }

  if (typeof end !== 'string' && Array.isArray(end)) {
    let next = v
    for (const e of end) {
      next = removeLast(next, e)
    }
    return next
  }

  return removeLast(v, end)
}

export const toTitle = (value: string) => {
  return value
    .replace('_', ' ')
    .toLowerCase()
    .split(' ')
    .map((it) =>
      Array.from(it)
        .map((ch, i) => (i <= 0 ? ch.toUpperCase() : ch))
        .join('')
    )
    .join(' ')
}

export const stringFit = (value: string, len: number, padWith: string): string => {
  return arrayFit(Array.from(value), len, padWith).join('');
}


export const containsNumber = (value: string): boolean => {
  return Array.from(value).some(c => isDigit(c));
}
